<template>
<div class="report_custom page-box">
<!--  统计本人直客和直接子IB的账户-->
  <query-header
    ref="header"
    :cent-account-config="centAccountConfig"
    @toQuery="toQuery"
  ></query-header>
  <div class="page-content">
    <div class="content-header">
      <el-input
        class="search-input"
        v-model="custInfo"
        :placeholder="$t('Customer_Name_ID_Trading_Account')"
        style="width: 200px"
        clearable
      ></el-input>
      <vs-button
        class="search-btn"
        @click="searchHandle"
      >{{$t('search')}}</vs-button>
    </div>
    <div class="vs-table-outer">
      <vs-table
        :noDataText="$t('root.noData')"
        :data="listData"
      >
        <template
          slot="thead">
          <vs-th>
            {{$t('transaction_account')}}
          </vs-th>
          <vs-th>
            {{$t('MT_group')}}
          </vs-th>

          <vs-th>
            {{$t('Belong_to_customers')}}
          </vs-th>
          <vs-th>
            {{$t('User.reportCusType')}}
          </vs-th>
          <vs-th>
            {{$t('Total_deposit')}}
          </vs-th>
          <vs-th>
            {{$t('Total_withdrawal')}}
          </vs-th>
          <vs-th>
            {{$t('balance')}}
          </vs-th>
          <vs-th>
            {{$t('equity')}}
          </vs-th>
          <vs-th>
            {{$t('Home.forexVolume')}}
          </vs-th>
          <vs-th>
            {{$t('transaction_status')}}
          </vs-th>
          <vs-th>
            {{$t('User.reportCreateTime')}}
          </vs-th>
        </template>
        <!--    合计项插没有生效 todo-->
        <template slot-scope="{data}">
          <vs-tr style="background-color:#F3F2F7;">
            <vs-td>
              {{$t('User.total')}}
            </vs-td>
            <vs-td>
              {{'-'}}
            </vs-td>
            <vs-td>
              {{'-'}}
            </vs-td>
            <vs-td>
              {{'-'}}
            </vs-td>
            <vs-td>
              {{statistics.depositSum}}
            </vs-td>
            <vs-td>
              {{statistics.withdrawSum}}
            </vs-td>
            <vs-td>
              {{statistics.balanceSum}}
            </vs-td>
            <vs-td>
              {{statistics.equitySum}}
            </vs-td>
            <vs-td>
              {{statistics.volumeSum || 0}}
            </vs-td>
            <vs-td>
              {{'-'}}
            </vs-td>
            <vs-td>
              {{'-'}}
            </vs-td>
          </vs-tr>
          <vs-tr :key="index" v-for="(tr, index) in data" >
            <vs-td>
              {{tr.login}}
            </vs-td>

            <vs-td>
              {{tr.accType}}
            </vs-td>

            <vs-td>
              <div>{{tr.userName}}</div>
              <div class="font999">{{tr.id}}</div>
            </vs-td>

            <vs-td>
              {{getCustomerType(tr)}}
            </vs-td>
            <vs-td>
              {{tr.deposit || '0'}}
            </vs-td>
            <vs-td>
              {{tr.withdraw || '0'}}
            </vs-td>
            <vs-td>
              {{tr.balance || '0'}}
            </vs-td>
            <vs-td>
              {{tr.equity || '0'}}
            </vs-td>
            <vs-td>
              {{tr.totalVolume || 0}}
            </vs-td>
            <vs-td>
              {{getStatus(tr)}}
            </vs-td>
            <vs-td>
              {{parseTime(tr.createTime)}}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="pagination-outer" v-if="total">
      <div class="paginnation-left">
        <size-change
          @sizeChange="sizeChange"
        ></size-change>
        <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
      </div>
      <vs-pagination
        class="pagination-box"
        :max="max"
        :total="pageSize"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
</div>
</template>

<script>
import { getMt4Group } from '@/api/userCenter.js'

import queryHeader from "@/components/agent/myCustomer/accountList/queryHeader";
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index';

// 表格字段需要重新调
import initData from "@/mixins/initData";

export default {
  name: "index",
  components: {
    queryHeader
  },
  data() {
    return {
      custInfo: '',

      statistics: {
        amount: '',
        amountOut: '',
        balance: '',
        valume: '',
      },
      centAccountConfig: true,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo','subIbJumpToAccountListOfId']),
  },
  created(){
    if(this.subIbJumpToAccountListOfId){
      this.custInfo = this.subIbJumpToAccountListOfId;
    }
  },
  mounted(){
    this.getMt4Group();
    this.init();
  },
  beforeDestroy(){
    this.$store.commit('setSubIbJumpToAccountListOfId', '');
  },
  methods: {
    parseTime,
    getMt4Group() {
      getMt4Group({
        isMock: 2
      }).then((res) => {

        this.centAccountConfig = res.data.some((item) => {
          return item.groupName == 'Cent';
        });
      });
    },
    beforeInit(){
      this.url = '/crm/reception/partner/loginList';
      this.params = {
        page: this.page -1,
        size: this.size,
        custId: this.userInfo.id,
        loginType: 3,// 账户列表需要排除本人数据 todo
      }
      let header = this.$refs.header;

      if(header.tradeType !== ''){
        this.params.enableReadOnly = header.tradeType;
      }
      if(this.custInfo){
        this.params.custInfo = this.custInfo;
      }
      this.params.currency = header.tabsType;
      return true;
    },
    getSystem(tr){
      return 'MT4'
    },
    getStatus(row){
      switch (row.enableReadOnly) {
        case 0 :
          return this.$t('normal');
        default:
          return this.$t('User.forbidden');
      }
    },
    getCustomerType(item){
      // 区分直客还是子IB
      return !item.ibRank ? this.$t('Straight_off'): this.$t('sub_IB');
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    refrash(){
      this.page = 1;
      this.init();
    }
  },
}
</script>

<style lang="scss" scoped>
.report_custom {
  .vs-con-table {
    min-width: 1200px;
  }
}
</style>
